module.exports = __webpack_public_path__ + "static/media/slide-xs-3.3470b56a.png";